<div class="bc-secondary-red-50 w-100 radius-8"
     [class.bc-secondary-red-50]="color === 'red'"
     [class.bc-secondary-yellow-100]="color === 'yellow'"
     fxLayout="column"
     fxLayoutAlign="center center">
    <span class="pre-line text-center t2 pt-12 pb-12 pl-8 pr-8">
       <ui-kit-svg
           class="i-16 mb-4"
           [class.c-secondary-red-800]="color === 'red'"
           [class.c-secondary-yellow-900]="color === 'yellow'"
           name="ic_warning_small">
       </ui-kit-svg>
       <span class='ml-4'
             [innerHTML]="errorWarningPanelTitle | translate: {class: errorClass} | safeHtml">
       </span>
    </span>
</div>

